<template>
	<div>
		<BaseAccordionController :accordion_header="getStateWithParam('contact')">
			<template v-slot:component>
				<component :is="contactBashkia" class="accordion-card-middle"></component>
			</template>
		</BaseAccordionController>
		<BaseAccordionController
			:accordion_header="getStateWithParam('label_info_education')"
			:expand_accondion="true"
		>
			<template v-slot:component>
				<div class="filter-indicator">
					<v-btn
						v-if="filteredcategory"
						@click="filteredcategory = null"
						class="grey--text text--darken-4"
						small
					>
						<div class="text-dart text-truncate mr-2">
							<img :src="currentcategory.icon" alt="currentcategory.name" height="16" style="float:left" class="mr-1">
							<span class="pt-1">{{currentcategory.name}}</span>
						</div>
						<v-icon small>close</v-icon>
					</v-btn>
				</div>
				<MapController
					:enableoptions="true"
					:optionsbottom="true"
					:hideoptions='hideoptions'
					:fitbounds="false"
				>
					<template v-for=" (feature, featureind) in featureslist ">
						<l-marker
							:key="'marker-' + featureind"
							:lat-lng="map_helper.getMarkerCoordinatesSwitch(feature.geometry.coordinates)"
							:icon="feature.properties.category ? map_helper.getIcon(feature.properties.category.icon) : map_helper.getIcon(icon_url)"
						>
							<l-popup>
								<div class="item item-divider" @click="popupAction(feature, {})">
									<span v-if="feature.properties.category">{{feature.properties.category.name}}</span>
									<div>{{feature.properties.poi_title}}</div>
								</div>
							</l-popup>
						</l-marker>
					</template>
					<template v-slot:options>
						<v-list>
							<template v-for="kategori in map_data.kategorite">
								<v-list-tile
									:key="'kategori-' + kategori.id"
									@click="filteredcategory = kategori.id"
								>
									<v-list-tile-avatar>
										<v-avatar size="32px" kategori>
											<img
												:src="kategori.icon"
												:alt="kategori.name"
											>
										</v-avatar>
									</v-list-tile-avatar>
									<v-list-tile-content>
										<v-list-tile-title>{{ kategori.name }}</v-list-tile-title>
									</v-list-tile-content>
									<v-list-tile-action>
										<v-switch v-model="filteredcategory" :value="kategori.id"></v-switch>
									</v-list-tile-action>
								</v-list-tile>
								<v-divider inset :key="'kategoridivider-' + kategori.id"></v-divider>
							</template>
						</v-list>
					</template>
				</MapController>
			</template>
		</BaseAccordionController>
	</div>
</template>

<script>
import MapController from "@/components/cards/MapController.vue";
import { LGeoJson, LMarker, LPopup } from "vue2-leaflet";
import ContactBashkia from "@/components/cards/ContactBashkiaCard.vue";
import info from "@/config/api/api_events/info.js";
import map_helper from "@/config/js_helper/map_helper.js";

export default {
  	name: "Education",
	components: {
		MapController,
		LGeoJson,
		LMarker,
		LPopup,
	},
	data() {
		return {
			map_helper: map_helper,
			map_data: [],
			from_where: 10,
			icon_url: require("@/assets/img/new_icons/shkolle.svg"),
			contactBashkia: ContactBashkia,
			expand_accondion: true,
			hideoptions: false,
			filteredcategory: null,
		};
	},
	computed: {
		featureslist(){
			let list = []
			if (this.map_data.geodata && this.map_data.geodata.features) {
				if (this.filteredcategory) {
					list = this.map_data.geodata.features.filter( (feature) => feature.properties.category.id == this.filteredcategory )
				} else {
					list = this.map_data.geodata.features
				}
			}
			return list
		},
		currentcategory(){
			let categorykey = 'kategori_' + this.filteredcategory
			return this.map_data.kategorite.find(kategori => kategori.id == this.filteredcategory)
		}
	},
	watch: {
		filteredcategory(){
			this.hideoptions = !this.hideoptions
		},
	},
  	created(){
		this.getShkollatFromCall();
	},
	methods: {
		getShkollatFromCall() {
			info
			.getShkollat(this.getLangTypeToUse())
			.then(response => {
				this.$store.state.active_loader = false;
				this.map_data = response;
			})
			.then(response => {
				this.map_data.geodata.features.forEach(feature => {
					feature.properties.category = this.map_data.kategorite.find(kategori => kategori.id == feature.properties.category_id)
				});
			})
			.catch(error => {
				this.$store.state.active_loader = false;
				console.log(error, "getNjesiteLayers");
			});
		},
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		getLangTypeToUse() {
			return this.$store.state.type_language;
		}
	},
};
</script>

<style scope lang="scss" src="./Education.scss">
</style>